import React from "react";
import PropTypes from "prop-types";
import { Container, Grid, GridItem, Display3, Button, Box } from "@sainsburys-tech/fable";
import AlertListBody from "./AlertListBody";
import { alertListHeadingStyle, alertListItemBorderStyle } from "./alertListStyles";

const AlertList = props => (
  <div>
    <Container>
      <Grid cols={2} gap="md">
        <GridItem>
          {/* <h3 className="cb-u-component-header-title">Alerts</h3> */}
          <Display3 style={alertListHeadingStyle}>Alerts</Display3>
        </GridItem>
        {props.showFiltersButton && (
          <GridItem>
            <Button onClick={props.onFiltersClick} variant="dark">
              Filters
            </Button>
          </GridItem>
        )}
      </Grid>
    </Container>
    <AlertListBody {...props} />
  </div>
);

AlertList.propTypes = {
  pagedAlerts: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  showFiltersButton: PropTypes.bool,
  onFiltersClick: PropTypes.func.isRequired,
  redirectTo: PropTypes.object,
  pagingEnabled: PropTypes.bool,
  isPaging: PropTypes.bool,
  showAlertIdNotFoundMessage: PropTypes.bool
};

AlertList.defaultProps = {
  showFiltersButton: false
};

export default AlertList;
